import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ItestListItem } from '@ispm/dashboard/test/interfaces/test-list-item';

@Component({
  selector: 'ispm-vertical-test-actions-item',
  templateUrl: './vertical-test-actions-item.component.html',
  styleUrls: ['./vertical-test-actions-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalTestActionsItemComponent implements OnInit {
  @Input() test: ItestListItem;

  constructor() { }

  ngOnInit() {
  }

}
